module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer",
    attrs: {
      "role": "contentinfo"
    }
  }, [_c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "footer_misc"
  }, [_c('h4', [_vm._v(" ©2020")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Please do kindly tell me how I can improve my code.")]), _vm._v(" "), _c('li', [_vm._v("As always, this is a work in progress, just like I am.")]), _vm._v(" "), _c('li', [_vm._v("If you find accessible bugs, please "), _c('a', {
    attrs: {
      "href": "https://github.com/lesliedoherty/portfolio/issues"
    }
  }, [_vm._v("feel free to create an issue on github "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("in a new window")])]), _vm._v(" .")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9f26cc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partials/app-footer/AppFooter.vue
// module id = 94
// module chunks = 0